import { getMatchdays, getMatchdayNumber } from './matchdays';

const id = (value) => value == null ? '' : String(value);
const score = (value) => (typeof value === 'number' || typeof value === 'string') &&
  String(value).trim() !== '' && Number.isInteger(Number(value)) && Number(value) >= 0;
const date = (value) => {
  const raw = String(value || '');
  const match = raw.match(/^(\d{2})[-/](\d{2})[-/](\d{4})(.*)$/);
  return Date.parse(match ? `${match[3]}-${match[2]}-${match[1]}${match[4]}` : raw);
};

export function teamDirectorySummary(teamId, snapshots, calendar, now = Date.now()) {
  const latest = [...(Array.isArray(snapshots) ? snapshots : [])]
    .sort((a, b) => (getMatchdayNumber(b) ?? -1) - (getMatchdayNumber(a) ?? -1))[0];
  const standing = latest?.clasificacion?.find((team) => id(team.codequipo) === id(teamId));
  const matches = new Map();
  const conflicts = new Set();
  getMatchdays(calendar).forEach((round) => round.partidos?.forEach((match) => {
    const home = id(match.codEquipoLocal ?? match.idEquipoLocal);
    const away = id(match.codEquipoVisitante ?? match.idEquipoVisitante);
    if (home !== id(teamId) && away !== id(teamId)) return;
    const key = id(match.idPartido ?? match.id ?? match.codActa) || `${getMatchdayNumber(round)}:${home}:${away}`;
    const entry = { ...match, round: getMatchdayNumber(round), home, away };
    const previous = matches.get(key);
    if (previous && ['golesCasa', 'golesVisitante', 'partidoJugado', 'home', 'away'].some((field) =>
      String(previous[field]) !== String(entry[field]))) conflicts.add(key);
    matches.set(key, entry);
  }));
  const unique = [...matches].filter(([key]) => !conflicts.has(key)).map(([, match]) => match);
  const played = unique.filter((match) => match.partidoJugado === true && score(match.golesCasa) && score(match.golesVisitante));
  const dated = played.every((match) => Number.isFinite(date(match.fecha)));
  played.sort((a, b) => (dated ? date(a.fecha) - date(b.fecha) : 0) || a.round - b.round);
  const form = played.slice(-5).map((match) => {
    const difference = (Number(match.golesCasa) - Number(match.golesVisitante)) * (match.home === id(teamId) ? 1 : -1);
    return difference > 0 ? 'win' : difference < 0 ? 'loss' : 'draw';
  });
  const next = unique.filter((match) => match.partidoJugado === false && Number.isFinite(date(match.fecha)) && date(match.fecha) >= now)
    .sort((a, b) => date(a.fecha) - date(b.fecha))[0] || null;
  return { position: standing?.posicion ?? null, points: standing?.puntos ?? null, form, next, round: latest ? getMatchdayNumber(latest) : null };
}
